<template>
  <div class="main-filters">
      <div class="title-primary">
        Filtros
      </div>
    <div class="row">
      <div class="col-lg-5 col-md-12">
        <div class="title-filters">
          Fecha
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="baseline_box mb-2">
              <input type="date"
                     v-model="startDate"
                     :max="endDate"
                     :class="`form-control ${errors.start_date ? 'is-invalid' : null}`"
                     @input="processing_date = true"/>
              <div class="invalid-feedback">
                {{  errors.start_date ? errors.start_date[0] : null }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="baseline_box mb-2">
              <input type="date"
                     v-model="endDate"
                     :min="startDate"
                     :class="`form-control ${errors.end_date ? 'is-invalid' : null}`"
                     @input="processing_date = true"/>
              <div class="invalid-feedback">
                {{  errors.end_date ? errors.end_date[0] : null }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="title-filters">
          Area
        </div>
          <div class="filters-multiselect mt-4" tabindex="0">
            <multiselect v-model="selectedOperations"
                         :disabled="is_disabled"
                         :options="getOperations"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         placeholder="Areas"
                         label="name"
                         track-by="name"
                         :preselect-first="false"
                         :loading="processingOperations">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                  {{ values.length }} options selected
                </span>
              </template>
            </multiselect>
            <b-form-invalid-feedback id="input-operations-feedback">
              {{ getErrors(errors, 'operation').message }}
            </b-form-invalid-feedback>
          </div>
      </div>
      <template v-if="canWithCode('oh-specialist')">
        <div class="col-lg-3 col-md-6">
          <div class="title-filters">
            Site
          </div>
          <div class="filters-multiselect mt-4" tabindex="0">
            <multiselect v-model="selectedSites"
                         :disabled="is_disabled"
                         :options="getSites"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         placeholder="Sites"
                         label="name"
                         track-by="name"
                         :preselect-first="false"
                         :loading="processingSites">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                  {{ values.length }} options selected
                </span>
              </template>
            </multiselect>
            <b-form-invalid-feedback id="input-sites-feedback">
              {{ getErrors(errors, 'site').message }}
            </b-form-invalid-feedback>
          </div>
        </div>
      </template>
      <div class="col-lg-3 col-md-6" >
        <div class="title-filters">
          Empleado
        </div>
        <div class="filters-multiselect mt-4" tabindex="0">
          <multiselect v-model="selectedEmployees"
                       :disabled="is_disabled"
                       :options="getEmployeesBySearch"
                       :multiple="true"
                       :close-on-select="false"
                       :clear-on-select="false"
                       :preserve-search="true"
                       placeholder="Empleados"
                       label="name_cc_sharp_id"
                       track-by="name"
                       :preselect-first="false"
                       :searchable="true"
                       :internal-search="false"
                       @search-change="searchEmployee"
                       :loading="processingEmployees" >
            <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                  {{ values.length }} options selected
                </span>
            </template>
          </multiselect>

          <b-form-invalid-feedback id="input-employees-feedback">
            {{ getErrors(errors, 'employee').message }}
          </b-form-invalid-feedback>
        </div>
       </div>
      <div class="col-lg-3 col-md-6">
        <div class="title-filters">
          Tipo de ausentismo
        </div>
          <div class="filters-multiselect mt-4" tabindex="0">
            <multiselect v-model="selectedReasonNames"
                         :disabled="is_disabled"
                         :options="getReasonNames"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         placeholder="Tipos de ausentismos"
                         label="name"
                         track-by="name"
                         :loading="processingReasonNames"
                         :preselect-first="false">
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                  {{ values.length }} options selected
                </span>
              </template>
            </multiselect>

            <b-form-invalid-feedback id="input-employees-feedback">
              {{ getErrors(errors, 'reason_name').message }}
            </b-form-invalid-feedback>
          </div>
      </div>
      <div class="col-12">
          <button
              :disabled="!button_clear_filter_is_disabled "
              @click.prevent="forgetFilters"
              class="button-danger">
            Quitar todos los filtros
          </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapActions
    ,mapGetters
  } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'AbsFilter'
    ,props: {
      errors: []
    }
    ,components: {
      Multiselect: () =>  import('vue-multiselect')
    }
    ,data: () => ({
      processingOperations: true
      ,selectedOperations: []
      ,processingSites: true
      ,selectedSites: []
      ,processingReasonNames: true
      ,selectedReasonNames: []
      ,processingEmployees: false
      ,selectedEmployees: []
      ,startDate: null
      ,endDate: null
      , query_search_employee: ''
      , processing_query_search_employee: false
      , processing_date: false
    })
    ,computed: {
      is_disabled () {
        return (!this.endDate || !this.startDate)
      }
      , button_clear_filter_is_disabled () {
        return !!(this.selectedOperations.length || this.selectedSites.length
            || this.selectedReasonNames.length || this.selectedEmployees.length)
      }
      , ...mapGetters('modOhAnalyst', [
          'getEmployeesBySearch'
      ])
      , ...mapGetters('healthTrackerAbsenteeismV2InformationManagement', [
          'getOperations'
          ,'getSites'
          ,'getReasonNames'
      ])
    }
    ,beforeMount () {
      this.run()
    }
    , watch: {
      selectedOperations: _.debounce(function () {
          const values = this.changeSelected(this.selectedOperations)
          this.$emit('change:operations', values)
      }, 3000)
      , selectedSites: _.debounce(function () {
        const values = this.changeSelected(this.selectedSites)
        this.$emit('change:sites', values)
      }, 3000)
      , selectedReasonNames: _.debounce(function () {
        const values = this.changeSelected(this.selectedReasonNames)
        this.$emit('change:reasonNames', values)
      }, 3000)
      , selectedEmployees: _.debounce(function () {
        const values = this.changeSelected(this.selectedEmployees)
        this.$emit('change:employees', values)
      }, 3000)
      , query_search_employee: _.debounce(function () {
        this.processing_query_search_employee = false
      }, 3000)
      , processing_query_search_employee (value) {
        if (value) return
        this.startLookingEmployee ()
      }
      , endDate: _.debounce(function () {
        this.processing_date = false
      }, 3000)
      , startDate: _.debounce(function () {
        this.processing_date = false
      }, 3000)
      , processing_date (value)
      {
        if (value) return
        this.changeStartDate()
      }
    }
    ,methods: {
      ...mapActions('healthTrackerAbsenteeismV2InformationManagement', [
          'getOperationsStore'
          ,'getSitesStore'
          ,'getReasonNamesStore'
      ])
      ,...mapActions('modOhAnalyst', [
          'actGetEmployeesBySearch'
      ])
      , searchEmployee (value)
      {
        this.query_search_employee = value
        this.processing_query_search_employee = true
      }
      , async startLookingEmployee ()
      {
        this.processingEmployees = true
        await this.actGetEmployeesBySearch({
          search: this.query_search_employee
        }).finally(() => {
          this.processingEmployees = false
        })
      }
      ,changeSelected (values)
      {
        return values.map((value) => value.id)
      }
      ,getErrors (errors = [], key = '' )
      {
        let result = false
         Object.keys(errors).forEach((error, index) => {
          if (
              Object.keys(errors).includes(key.concat('.', index))
          ) {
            result = key.concat('.', index)
          }
        })
        return result ? { message: errors[result][0] , state: false } : { message: [], state:true }
      }
      ,forgetFilters ()
      {
        this.selectedOperations = []
        this.selectedSites = []
        this.selectedReasonNames = []
        this.selectedEmployees = []
        this.$emit('click:forgetFilter', { startDate:  this.startDate, endDate: this.endDate })
      }
      ,changeStartDate ()
      {
        if (!this.endDate || !this.startDate) return
        this.$emit('change:date', { startDate:  this.startDate, endDate: this.endDate })
      }
      ,async run()
      {
        await this.getOperationsStore().finally(() => {
          this.processingOperations = false
        })

        if (
            this.canWithCode('oh-specialist')
        ) {
          await this.getSitesStore().finally(() => {
            this.processingSites = false
          })
        }

        await this.getReasonNamesStore().finally(() => {
          this.processingReasonNames = false
        })

        await this.startLookingEmployee()

      }
    }
  }
</script>

<style lang="scss">
.main-filters{
  box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 15%);
  border-radius: 5px;
  padding: 25px;
  border-bottom: 1px solid #e9e9e9;
  margin-bottom: 30px;
}
.title-primary{
font-size: 24px;
font-weight: 600;
}

.title-filters{
  border-bottom: 1px solid #CCC;
  color: #1C6776;
  display: inline-block;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 20px;
  font-family: Ubuntu;
  font-size: 22px;
  font-weight: 500;
}
.baseline_box input{
  width: 95%;
}
.filters-multiselect{
  .multiselect {
    height: 44px;
  }
  .multiselect__tags{
    background-color: transparent;
  }
  .multiselect__option--selected.multiselect__option--highlight{
    background-color: #da1414;
    &:after{
      background-color: #da1414;
    }
  }
}
.text-muted {
  position: relative;
  left: initial;
  top: 0;
  padding: 0;
  width: 100%;
  text-align: left;
}
@media (min-width: 992px) {
.title-primary{
  text-align: left;
}
.title-filters {
  width: 100%;
  text-align: left;
}
}

.vue-monthly-picker {
  font-family: Ubuntu;
  font-style: normal;
  font-weight: 300 !important;
  font-size: 16px;
  margin-top: 8px;
  padding-left: 10px;
}

.text-input {
  position: absolute;
  left: 16px;
  top: -6px;
  font: normal normal 300 12px/1 "Ubuntu";
  color: #78909C;
  background: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 4px;
  padding: 0px 4px;
  z-index: 9;
}

.button-danger{
border-radius: 20px;
padding: 4px 8px;
}
</style>